import { ResponseStatusEnum } from './responseStatusEnum';

export class ResponseBaseDTO {
    status: ResponseStatusEnum;
    message?: string;

    constructor () {
        this.status = ResponseStatusEnum.ok;
    }
}



// WEBPACK FOOTER //
// ./src/app/DTO/responseBaseDTO.ts